/**
 * @generated SignedSource<<33c0770e83bf103ad9484cb7bd6d74b8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PromptCategory = "ABOUT_ME" | "DATING" | "HOBBIES_INTERESTS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PromptSelectInput_query$data = {
  readonly prompts: {
    readonly nodes: ReadonlyArray<{
      readonly category: PromptCategory;
      readonly question: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "PromptSelectInput_query";
};
export type PromptSelectInput_query$key = {
  readonly " $data"?: PromptSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromptSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromptSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "deletedAt": {
              "isNull": true
            }
          }
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "PromptConnection",
      "kind": "LinkedField",
      "name": "prompts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Prompt",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "category",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "question",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "prompts(filter:{\"deletedAt\":{\"isNull\":true}},orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fa4dda58096b552e37dc332e8a89f8dc";

export default node;
